import { skipToken, useQuery } from '@tanstack/react-query'
import { getValuationApiClient } from 'ClientPortal/src/api/valuationApiClient'
import { WithReactQueryOptions } from 'ComponentLibrary'
import { getSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'

export const VALUE_CHECK_KEYS = {
    all: ['VALUE_CHECK'],
    lists: () => [...VALUE_CHECK_KEYS.all, 'list'],
    list: (filters: Record<string, unknown>) => [...VALUE_CHECK_KEYS.lists(), { filters }],
    single: ({ valueCheckId, customerId }: { valueCheckId: string | undefined; customerId: string | undefined }) => [
        ...VALUE_CHECK_KEYS.all,
        { valueCheckId, customerId },
    ],
}

export function useGetValueCheck({ valueCheckId, ...options }: WithReactQueryOptions<{ valueCheckId: string | undefined }>) {
    const valuationApiClient = getValuationApiClient()
    const customerId = getSelectedCustomer()?.uuid

    const { data, isPending } = useQuery({
        queryKey: VALUE_CHECK_KEYS.single({ valueCheckId, customerId }),
        queryFn: valueCheckId ? () => valuationApiClient.valueChecks.getValueCheck({ valueCheckId, customerId }) : skipToken,
        ...options,
    })

    return { valueCheck: data, isValueCheckPending: isPending }
}

export function useGetValueChecks({
    assetId,
    customerId,
    baseValuationId,
}: {
    assetId?: string
    customerId?: string
    baseValuationId?: string
}) {
    const valuationApiClient = getValuationApiClient()

    const searchParams: { assetId?: string; customerId?: string; baseValuationId?: string } = {}
    if (assetId) {
        searchParams.assetId = assetId
    }
    if (customerId) {
        searchParams.customerId = customerId
    }
    if (baseValuationId) {
        searchParams.baseValuationId = baseValuationId
    }

    const { data, isPending } = useQuery({
        queryKey: VALUE_CHECK_KEYS.list(searchParams),
        queryFn: () =>
            valuationApiClient.valueChecks.getValueChecks({
                ...searchParams,
                customerId: getSelectedCustomer()?.uuid || searchParams.customerId,
            }),
        enabled: Boolean(assetId || customerId || baseValuationId),
    })

    return { valueChecks: data?.value_checks || [], isValueChecksPending: isPending }
}
